import {
  TableItemSkeleton,
  TableCellSkeleton,
  TableRowSkeleton,
  TableHeaderSkeleton,
} from '@acceso/design-system';

export function UserPageSkeleton() {
  return (
    <div className="flex flex-col rounded bg-neutral-00">
      <TableHeaderSkeleton>
        <TableItemSkeleton className="h-8 w-56" />
        <TableItemSkeleton className="h-10 w-16" />
      </TableHeaderSkeleton>
      <TableRowSkeleton>
        <TableCellSkeleton>
          <TableItemSkeleton className="h-5 w-20" />
        </TableCellSkeleton>
        <TableCellSkeleton className="flex w-1/2 items-center space-x-2">
          <TableItemSkeleton className="h-[26px] w-[26px]" rounded="full" />
          <TableItemSkeleton className="h-3.5 w-32" />
        </TableCellSkeleton>
      </TableRowSkeleton>
      <TableRowSkeleton>
        <TableCellSkeleton>
          <TableItemSkeleton className="h-5 w-12" />
        </TableCellSkeleton>
        <TableCellSkeleton>
          <TableItemSkeleton className="h-5 w-40" />
        </TableCellSkeleton>
      </TableRowSkeleton>
      <TableRowSkeleton>
        <TableCellSkeleton>
          <TableItemSkeleton className="h-5 w-16" />
        </TableCellSkeleton>
        <TableCellSkeleton>
          <TableItemSkeleton className="h-5 w-32" />
        </TableCellSkeleton>
      </TableRowSkeleton>
      <TableRowSkeleton>
        <TableCellSkeleton>
          <TableItemSkeleton className="h-5 w-20" />
        </TableCellSkeleton>
        <TableCellSkeleton className="flex w-1/2 space-x-2">
          <TableItemSkeleton className="h-[26px] w-[26px]" rounded="full" />
          <div className="flex flex-col space-y-1.5">
            <TableItemSkeleton className="h-3.5 w-24" />
            <TableItemSkeleton className="h-3 w-16" />
          </div>
        </TableCellSkeleton>
      </TableRowSkeleton>
      <TableRowSkeleton>
        <TableCellSkeleton>
          <TableItemSkeleton className="h-5 w-28" />
        </TableCellSkeleton>
        <TableCellSkeleton className="flex w-1/2 space-x-2">
          <TableItemSkeleton className="h-[26px] w-[26px]" rounded="full" />
          <div className="flex flex-col space-y-1.5">
            <TableItemSkeleton className="h-3.5 w-32" />
            <TableItemSkeleton className="h-3 w-28" />
          </div>
        </TableCellSkeleton>
      </TableRowSkeleton>
    </div>
  );
}
